import { Link } from "react-router-dom";
import { ArrowRight, Check, MoveUpRight } from "lucide-react";
import { LOGOS, CALENDLY } from "@/data";

export const TRIAL_NOTE = "Two months free, with a resolution allowance agreed before activation.";
export const money = (amount) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(amount);
export const slugify = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "");

export const TrialLink = ({ children = <>Try free for two months <ArrowRight size={16} /></>, testId, className = "qd-button" }) => (
  <a href={CALENDLY} target="_blank" rel="noopener noreferrer" className={className} data-testid={testId}>{children}</a>
);

export const SectionIntro = ({ label, title, description, testId }) => (
  <div className="qd-section-intro" data-testid={testId}>
    <p className="qd-eyebrow">{label}</p>
    <h2>{title}</h2>
    {description && <p className="qd-description">{description}</p>}
  </div>
);

export const PageIntro = ({ label, title, description, children, testId }) => (
  <header className="qd-page-intro qd-container" data-testid={testId}>
    <p className="qd-eyebrow">{label}</p>
    <h1>{title}</h1>
    {description && <p className="qd-description">{description}</p>}
    {children}
  </header>
);

export const ChannelStrip = ({ names, testId }) => (
  <div className="qd-channel-strip" data-testid={testId}>
    {names.map((name) => <span key={name}><img src={LOGOS[name]} width="22" height="22" alt="" loading="lazy" decoding="async" />{name}</span>)}
  </div>
);

export const FeatureList = ({ items, testId }) => (
  <ul className="qd-feature-list" data-testid={testId}>{items.map((item, i) => <li key={item} data-testid={`${testId}-${i}`}><Check size={17} /><span>{item}</span></li>)}</ul>
);

export const PricingTerms = ({ testId }) => (
  <div className="qd-pricing-terms" data-testid={testId}>
    <div><span>01 / FORECAST</span><strong data-testid={`${testId}-base`}>$0.79 per resolution</strong><p>Prebuy resolution credits based on the support volume you expect.</p></div>
    <div><span>02 / CARRY FORWARD</span><strong data-testid={`${testId}-rollover`}>Unused stays yours</strong><p>Unused prepaid credits carry forward into your next billing period.</p></div>
    <div><span>03 / FLEX</span><strong data-testid={`${testId}-overage`}>$0.99 per extra resolution</strong><p>Only resolutions beyond your available credits incur the overage rate.</p></div>
    <div><span>04 / AI PLATFORM CREDITS</span><strong data-testid={`${testId}-ai-credits`}>AI platform credit costs excluded</strong><p>AI platform credit costs are not included in resolution pricing and are subject to disclosures during your demo.</p></div>
  </div>
);

export const ValidationCTA = ({ testId = "validation-cta" }) => (
  <section className="qd-validation-band" data-testid={testId}>
    <div className="qd-container qd-split">
      <div><p className="qd-eyebrow">A helping hand. Not a sales pitch.</p><h2>Validate your customer support operations. For free.</h2><p>Tell us what’s getting in the way. We want to help you solve it, whether or not you choose QuantumDesk.</p></div>
      <Link to="/#audit" className="qd-button qd-button-outline" data-testid={`${testId}-link`}>Let’s look at your support <MoveUpRight size={17} /></Link>
    </div>
  </section>
);